import {Pipe, PipeTransform} from '@angular/core';

export type StripHtmlMode = 'all' | 'body' | 'listApp' | 'notes' | 'biblio' | 'trans_en' | 'trans_la';

@Pipe({
    name: 'stripHtml'
})
export class StripHtmlPipe implements PipeTransform {

    transform(content: string, mode: StripHtmlMode = 'all'): string {
        switch (mode) {
            case 'body':
            case 'listApp':
            case 'biblio':
            case 'trans_en':
            case 'trans_la':
                return content.replace(/<[\/]?a.*?>/g, '');
            case 'notes':
                return content.replace(/<[\/]?a.*?>|<i(?![^>]+(hl-icon|dir=))[^>]+>[^<]*<\/i>|note_row/g, '');
            case 'all':
            default:
                return content.replace(/<.*?>/g, '');
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/pipes/strip-html.pipe.ts